export enum ChipInputType {
  Selection,
  Autocomplete,
}
